<div
  class="patient-identity"
  [class.patient-identity--compact]="compact"
  [class.patient-identity--mobile-name-only]="mobileNameOnly"
>
  @if (showAvatar) {
    <span class="patient-identity__avatar" aria-hidden="true">{{ initials }}</span>
  }
  <span class="patient-identity__content">
    @if (route) {
      <a
        class="patient-identity__name patient-identity__name--link"
        [routerLink]="route"
        [attr.aria-label]="'Abrir ficha de ' + displayName"
        (click)="stopRowAction($event)"
      >
        {{ displayName }}
      </a>
    } @else {
      <span class="patient-identity__name">{{ displayName }}</span>
    }
    @if (subtitle) {
      <span class="patient-identity__subtitle">
        @if (subtitleIcon) {
          <mat-icon>{{ subtitleIcon }}</mat-icon>
        }
        <span>{{ subtitle }}</span>
      </span>
    }
    <ng-content></ng-content>
  </span>
</div>
